import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrows-up",
  "use": "icon-arrows-up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrows-up\"><defs><style type=\"text/css\"></style></defs><path d=\"M513 395.1L811.4 693.5c11.7 11.7 30.7 11.7 42.39999999 0s11.7-30.7 1e-8-42.4l-317.7-317.7c-0.6-0.7-1.2-1.4-1.9-2.1-11.7-11.7-30.7-11.7-42.4 0l-319.4 319.4c-11.7 11.7-11.7 30.7 0 42.4s30.7 11.7 42.4 0L513 395.1z\" p-id=\"3037\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrows-up.svg
// module id = 9n4a
// module chunks = 65